import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TMtdApi } from './types';

export const mtd: TMtdApi = {
	getMtdReports: (payload) =>
		http.post(endpoint.mtd.GET_MTD_REPORTS, payload).then((response) => response.data),
	addComment: (payload) =>
		http.post(endpoint.mtd.ADD_MTD_COMMENT(String(payload.id)), { comment: payload.comment }),
	getMtdReport: (id) => http.get(endpoint.mtd.GET_MTD_REPORT(id)).then((response) => response.data),
	sendMtdFileReport: (payload) =>
		http
			.post(endpoint.mtd.SEND_MTD_FILE_REPORT(String(payload.id)), payload.data)
			.then((response) => response.data),
	calculateMtdData: (payload) =>
		http
			.post(endpoint.mtd.CALCULATE_MTD_REPORT_DATA(String(payload.id)))
			.then((response) => response.data),
	downloadMtdReportPdf: (id) =>
		http
			.get(endpoint.mtd.DOWNLOAD_MTD_REPORT_PDF(String(id)), { responseType: 'blob' })
			.then((response) => response.data),
	updateObligations: (payload) =>
		http
			.post(endpoint.mtd.UPDATE_OBLIGATIONS(payload.emId, payload.startDate))
			.then((response) => response.data),
	getManualProcessing: (emId) =>
		http.get(endpoint.mtd.GET_MANUAL_PROCESSING(emId)).then((response) => response.data),
	updateManualProcessing: (payload) =>
		http.put(endpoint.mtd.UPDATE_MANUAL_PROCESSING, payload).then((response) => response.data),
};
